import React, { useMemo } from 'react';
import { ColorId } from 'referral-types';
import chroma from 'chroma-js';
import { GridSubthemeProps, useGridSubthemeColors } from './gridSubthemeShared';

const GridPaperBackground: React.FC<GridSubthemeProps> = (props) => {
  const resolvedColors = useGridSubthemeColors(props.themeRevision, {
    colorId1: ColorId.Gray1,
    colorId2: ColorId.Gray4,
  });

  const lineColors = useMemo(() => {
    return {
      minor: chroma(resolvedColors.color2).alpha(0.18).css(),
      major: chroma(resolvedColors.color2).alpha(0.38).css(),
    };
  }, [resolvedColors.color2]);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        backgroundColor: resolvedColors.color1,
        backgroundImage: `
          linear-gradient(to right, ${lineColors.minor} 1px, transparent 1px),
          linear-gradient(to bottom, ${lineColors.minor} 1px, transparent 1px),
          linear-gradient(to right, ${lineColors.major} 1px, transparent 1px),
          linear-gradient(to bottom, ${lineColors.major} 1px, transparent 1px)
        `,
        backgroundSize: '28px 28px, 28px 28px, 140px 140px, 140px 140px',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
      }}
    />
  );
};

export default GridPaperBackground;
